module.exports = "/fonts/fa-regular-400.woff2?33f727ccde4b05c0ed143c5cd78cda0c";